"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function scrollTrigger(triggerCallback, scrollElement, trigger) {
    var tm;
    var onScroll = function (e) {
        if (e.target !== scrollElement)
            return; //only listen to scrollElement scroll
        window.clearTimeout(tm); // Clear
        tm = setTimeout(function () {
            var contentHeight = scrollElement.scrollHeight;
            var pageHeight = scrollElement.clientHeight;
            var offsetY = scrollElement.scrollTop;
            var scrollPercent = (offsetY + pageHeight) / contentHeight;
            //fire trigger only when scrolled passed trigger threshold and page content height is greater than window height
            if (scrollPercent >= trigger && contentHeight > pageHeight) {
                scrollElement.removeEventListener('scroll', onScroll, true);
                triggerCallback();
            }
        }, 50);
    };
    scrollElement.addEventListener('scroll', onScroll, true);
    return function () { return scrollElement.removeEventListener('scroll', onScroll, true); };
}
function useScrollTrigger(_a, deps) {
    if (deps === void 0) { deps = []; }
    var _b = _a.scrollElement, scrollElement = _b === void 0 ? document.documentElement : _b, _c = _a.trigger, trigger = _c === void 0 ? 0.9 : _c, props = __rest(_a, ["scrollElement", "trigger"]);
    react_1.useEffect(function () {
        var removeScrollTrigger;
        if (scrollElement) {
            removeScrollTrigger = scrollTrigger(props.onScrollTrigger, scrollElement, trigger);
        }
        return function () {
            if (removeScrollTrigger)
                removeScrollTrigger();
        };
    }, __spread(deps));
}
exports.useScrollTrigger = useScrollTrigger;
